/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";

import { SharedStateStore } from "../store/SharedStateStore";

/**
 * Set the currently selected team unique identifier in the shared state store.
 * Team id is a string representing the unique identifier of the team specific to Shifts.
 * @example setTeamId("TEAM_00000000-0000-0000-0000-000000000000")
 */
export const setTeamId = mutatorAction("setTeamId", (teamId: string) => {
    SharedStateStore().teamId = teamId;
});
